import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faGlobe } from '@fortawesome/pro-duotone-svg-icons';

/**
 * Full-viewport notice for a FOREIGN host that resolves no brand (an enterprise custom
 * domain that is unregistered, still pending DNS validation, or disconnected). Sibling of
 * ConfigErrorComponent, deliberately its own face: nothing is broken on the platform — the
 * DOMAIN is simply not connected — and the only address we can honestly offer from an
 * unrecognized host is the Branduals site itself. Renders the global `.empty-state` block
 * (the page-state canon) inside the same viewport wrapper the sibling uses.
 */
@Component({
  selector: 'app-domain-not-connected',
  standalone: true,
  imports: [TranslateModule, FontAwesomeModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="domain-not-connected-viewport">
      <div class="empty-state">
        <fa-duotone-icon [icon]="faGlobe" class="empty-icon"></fa-duotone-icon>
        <h2>{{ 'domainNotConnected.title' | translate }}</h2>
        <p>{{ 'domainNotConnected.description' | translate: { hostname } }}</p>
        <a class="visit-link" href="https://www.branduals.com">{{ 'domainNotConnected.visitLink' | translate }}</a>
      </div>
    </div>
  `,
  styles: [`
    .domain-not-connected-viewport {
      display: flex;
      flex-direction: column;
      height: 100vh;
    }

    .visit-link {
      margin-top: 0.75rem;
      font-size: 0.875rem;
      color: var(--p-primary-color);
    }
  `],
})
export class DomainNotConnectedComponent {
  protected readonly faGlobe = faGlobe;
  protected readonly hostname = window.location.hostname;
}
